var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "base-modal",
    { ref: "modal", attrs: { "max-with": "1000", title: "Crear Ticket" } },
    [
      _c("template", { slot: "icon" }, [
        _vm.step === 0
          ? _c("div", [
              _c("img", {
                staticClass: "mr-2",
                attrs: {
                  src: require("@/assets/IconTNW.svg"),
                  width: "30px",
                  height: "30px"
                }
              })
            ])
          : _c(
              "div",
              { staticClass: "mr-2" },
              [
                _c(
                  "icon-button",
                  {
                    attrs: { title: "Volver" },
                    on: {
                      click: function() {
                        return (this$1.step = 0)
                      }
                    }
                  },
                  [_vm._v("mdi-arrow-left")]
                )
              ],
              1
            )
      ]),
      _c(
        "v-container",
        { staticClass: "white py-0 ma-0", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-fade-transition",
                    [
                      _vm.step === 0
                        ? _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    justify: "center",
                                    "no-gutters": ""
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "ma-2 selection-title" },
                                    [
                                      _vm._v(
                                        " Selecciona el tipo de ticket que deseas crear: "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm.$can(_vm.createAction, _vm.pdtResourceName)
                                ? _c(
                                    "v-col",
                                    [
                                      _c(
                                        "option-card",
                                        {
                                          attrs: {
                                            image: require("@/assets/tickets-r3-datacenter-access.png")
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.go("access-create")
                                            }
                                          }
                                        },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(" Acceso al Data Center ")
                                          ]),
                                          _c("template", { slot: "content" }, [
                                            _vm._v(
                                              " Aquí puedes tramitar un permiso de acceso para ingresar físicamente a las instalaciones del Centro Tecnológico Daycohost. "
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.$can(
                                _vm.createAction,
                                _vm.remoteHandsResourceName
                              ) ||
                              _vm.$can(
                                _vm.createAction,
                                _vm.ticketsResourceName
                              )
                                ? _c(
                                    "v-col",
                                    [
                                      _c(
                                        "option-card",
                                        {
                                          attrs: {
                                            image: require("@/assets/tickets-r3-req.png")
                                          },
                                          on: {
                                            click: function() {
                                              return (this$1.step = 1)
                                            }
                                          }
                                        },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(" Requerimientos ")
                                          ]),
                                          _c("template", { slot: "content" }, [
                                            _vm._v(
                                              " Puedes crear solicitudes relacionadas con la gestión de tus servicios, tales como: asistencia remota, manejo de cintas, soporte en plataformas y gestión administrada de nube. "
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.$can(
                                _vm.createAction,
                                _vm.ticketsResourceName
                              )
                                ? _c(
                                    "v-col",
                                    {
                                      on: {
                                        click: function() {
                                          return (this$1.step = 2)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "option-card",
                                        {
                                          attrs: {
                                            image: require("@/assets/tickets-r3-issues.png")
                                          }
                                        },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(" Incidentes ")
                                          ]),
                                          _c("template", { slot: "content" }, [
                                            _vm._v(
                                              " Puedes reportar cualquier inconveniente o degradación que afecte la disponibilidad de tus servicios administrados por Daycohost. "
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm.step == 1
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    justify: "center",
                                    "no-gutters": ""
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "ma-2 selection-title" },
                                    [
                                      _vm._v(
                                        " Selecciona el tipo de ticket de requerimiento que deseas crear: "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "v-col",
                                [
                                  _vm.$can(
                                    _vm.createAction,
                                    _vm.remoteHandsResourceName
                                  )
                                    ? _c(
                                        "requirement-option",
                                        {
                                          attrs: {
                                            image: require("@/assets/tickets-r3-remote-assistance.png")
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.go("remote-assistance")
                                            }
                                          }
                                        },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(" Asistencia Remota ")
                                          ]),
                                          _c("template", { slot: "content" }, [
                                            _vm._v(
                                              " Puedes solicitar de forma remota la realización de tareas como encendido, apagado o reinicio de equipos, toggling de switches, validación de conexión del cableado y observación bajo demanda de indicadores visuales de tus equipos. "
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _vm.$can(
                                    _vm.createAction,
                                    _vm.ticketsResourceName
                                  )
                                    ? _c(
                                        "requirement-option",
                                        {
                                          attrs: {
                                            image: require("@/assets/tickets-r3-tape-mgt.png")
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.go("tape-management")
                                            }
                                          }
                                        },
                                        [
                                          _c("template", { slot: "title" }, [
                                            _vm._v(" Gestión de Cintas ")
                                          ]),
                                          _c("template", { slot: "content" }, [
                                            _vm._v(
                                              " Puedes solicitar colocación de cintas, programar entrega y recepción de cintas y consultar el inventario de cintas en bóveda. "
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    : _vm._e(),
                                  _c(
                                    "requirement-option",
                                    {
                                      attrs: {
                                        image: require("@/assets/tickets-r3-req--network-security-internet.png")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.go(
                                            "network-security-and-internet"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" Redes, Seguridad e Internet ")
                                      ]),
                                      _c("template", { slot: "content" }, [
                                        _vm._v(
                                          " Crear solicitudes relacionadas con aumento o disminución de ancho de banda, configuración de equipos, administración de cuentas VPN, políticas de acceso, navegación y reportes. "
                                        )
                                      ])
                                    ],
                                    2
                                  ),
                                  _c(
                                    "requirement-option",
                                    {
                                      attrs: {
                                        image: require("@/assets/tickets-r3-mgt-admin-services.png")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.go(
                                            "management-and-managed-services"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          " Gestión y Servicios Administrados "
                                        )
                                      ]),
                                      _c("template", { slot: "content" }, [
                                        _vm._v(
                                          " Crear solicitudes referidas a configuración de servidores, administración de sistema operativo, bases de datos, respaldo, DNS, certificados de seguridad, acreditación de usuarios, evaluaciones de salud y reportes de desempeño. "
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.step == 2
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    justify: "center",
                                    "no-gutters": ""
                                  }
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "ma-2 selection-title" },
                                    [
                                      _vm._v(
                                        " Selecciona el tipo de ticket de incidente que deseas crear: "
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "requirement-option",
                                    {
                                      attrs: {
                                        image: require("@/assets/tickets-r3-link-mgt.png")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.go("link-management")
                                        }
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" Gestión de Enlaces ")
                                      ]),
                                      _c("template", { slot: "content" }, [
                                        _vm._v(
                                          " Puedes crear incidentes relacionados con los servicios de conectividad provistos por Daycohost. "
                                        )
                                      ])
                                    ],
                                    2
                                  ),
                                  _c(
                                    "requirement-option",
                                    {
                                      attrs: {
                                        image: require("@/assets/tickets-r3-processing-admin-mgt.png")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.go(
                                            "processing-and-managed-management"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(
                                          " Procesamiento y Gestión Administrada "
                                        )
                                      ]),
                                      _c("template", { slot: "content" }, [
                                        _vm._v(
                                          " Puedes crear incidentes asociados a la disponibilidad de los servicios de procesamiento y gestión administrada de servidores de nube, provistos por Daycohost. "
                                        )
                                      ])
                                    ],
                                    2
                                  ),
                                  _c(
                                    "requirement-option",
                                    {
                                      attrs: {
                                        image: require("@/assets/tickets-r3-issues--network-security-internet.png")
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.go(
                                            "network-security-internet-incident"
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("template", { slot: "title" }, [
                                        _vm._v(" Redes, Seguridad e Internet ")
                                      ]),
                                      _c("template", { slot: "content" }, [
                                        _vm._v(
                                          " Puedes crear incidentes detectados en la disponibilidad de los servicios de comunicaciones relacionados con Redes, Seguridad de Información e Internet, provistos por Daycohost. "
                                        )
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }